import "./index.less";
import React, { FC, memo } from "react";
import User from "./User";
import { useGlobalStore } from "@/store/hooks";
import { observer } from "mobx-react-lite";
import { Dropdown, Menu } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";

interface HeaderProps {
  collapsed?: boolean;

  onCollapse?: React.Dispatch<boolean>;
}

const Header: FC<HeaderProps> = (props) => {
  const globalStore = useGlobalStore();

  const menu = (
    <Menu>
      <Menu.Item onClick={globalStore.loginOut}>安全退出</Menu.Item>
    </Menu>
  );

  return (
    <div className="ec-header-container">
      <div className="ec-header-middle-container">
        <div className="collapsed-container">
          {props.collapsed ? (
            <MenuUnfoldOutlined
              onClick={() => {
                props.onCollapse?.(!props.collapsed);
              }}
            />
          ) : (
            <MenuFoldOutlined
              onClick={() => {
                props.onCollapse?.(!props.collapsed);
              }}
            />
          )}
        </div>
      </div>

      <div className="ec-header-right">
        <a className="mr20" href="tencent://Message/?Uin=800183878&websiteName=q-zone.qq.com&Menu=yes" id="contact">
          联系客服
        </a>

        <Dropdown overlay={menu} trigger={["hover"]}>
          <div>
            <User src={globalStore.user?.avatarUrl} name={globalStore.user?.nickName} />
          </div>
        </Dropdown>
      </div>
    </div>
  );
};

export default memo(observer(Header));
